import React from "react";
import { formatTabNotificationCount } from "../utils/dashboardTabNotifications";

export default function DashboardModuleTabBadge({ count, onNavigate, buildPath, tabKey }) {
  const label = formatTabNotificationCount(count);
  if (!label) return null;

  return (
    <button
      type="button"
      className="buyer-dashboard__module-tab-badge"
      title="View related notifications"
      aria-label={`${label} unread notifications`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onNavigate(buildPath(tabKey));
      }}
    >
      {label}
    </button>
  );
}
